import { alpha } from "@material-ui/core/styles/colorManipulator";
export var createMuiListItemOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        root: {
            paddingTop: spacing(2),
            paddingBottom: spacing(2),
        },
        dense: {
            paddingTop: 0,
            paddingBottom: 0,
        },
        gutters: {
            paddingLeft: spacing(2),
            paddingRight: spacing(2),
        },
        secondaryAction: {
            paddingRight: spacing(12),
        },
        selected: {
            backgroundColor: alpha(palette.text.primary, 0.04),
        },
    });
};
//# sourceMappingURL=MuiListItem.js.map